import { createWebHistory, createRouter } from 'vue-router'
import store from '@/store'
import LoginPage from '@/pages/LoginPage.vue'
import MainPage from '@/pages/MainPage.vue'
// lazy-loaded
const SettingPage = () => import('@/pages/SettingPage.vue')
const ResetPasswordPage = () => import('@/pages/ResetPasswordPage.vue')
const NewPasswordPage = () => import('@/pages/NewPasswordPage.vue')
const PropertyPage = () => import('@/pages/PropertyPage.vue')
const LegalStructurePage = () => import('@/pages/LegalStructurePage.vue')
const OwnerPage = () => import('@/pages/OwnerPage.vue')
const TenantPage = () => import('@/pages/TenantPage.vue')
const RentingPage = () => import('@/pages/RentingPage.vue')
const ExpensePage = () => import('@/pages/ExpensePage.vue')
const FinancierPage = () => import('@/pages/FinancierPage.vue')
const BankAccountPage = () => import('@/pages/BankAccountPage.vue')
const BalanceSheetPage = () => import('@/pages/BalanceSheetPage.vue')
const ImportExportPage = () => import('@/pages/ImportExportPage.vue')
const TaskPage = () => import('@/pages/TaskPage.vue')
const UserPage = () => import('@/pages/UserPage.vue')

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: { authRequired: false },
    },
    {
        path: '/',
        name: 'main',
        alias: ['/name'],
        component: MainPage,
        meta: { authRequired: true },
    },
    {
        path: '/reset-password',
        name: 'reset_password',
        component: ResetPasswordPage,
        meta: { authRequired: false },
    },
    {
        path: '/new-password',
        name: 'new_password',
        component: NewPasswordPage,
        meta: { authRequired: false },
    },
    {
        path: '/:account?/setting/:component?',
        name: 'setting',
        // lazy-loaded
        component: SettingPage,
        meta: { authRequired: true },
    },
    {
        path: '/property',
        name: 'property',
        // lazy-loaded
        component: PropertyPage,
        meta: { authRequired: true },
    },
    {
        path: '/legal-structure',
        name: 'legal_structure',
        // lazy-loaded
        component: LegalStructurePage,
        meta: { authRequired: true },
    },
    {
        path: '/owner',
        name: 'owner',
        // lazy-loaded
        component: OwnerPage,
        meta: { authRequired: true },
    },
    {
        path: '/tenant',
        name: 'tenant',
        // lazy-loaded
        component: TenantPage,
        meta: { authRequired: true },
    },
    {
        path: '/renting',
        name: 'renting',
        // lazy-loaded
        component: RentingPage,
        meta: { authRequired: true },
    },
    {
        path: '/financier/:renting_uuid?',
        name: 'financier',
        // lazy-loaded
        component: FinancierPage,
        meta: { authRequired: true },
    },
    {
        path: '/task',
        name: 'task',
        // lazy-loaded
        component: TaskPage,
        meta: { authRequired: true },
    },
    {
        path: '/expense',
        name: 'expense',
        // lazy-loaded
        component: ExpensePage,
        meta: { authRequired: true },
    },
    {
        path: '/balance-sheet',
        name: 'balance_sheet',
        // lazy-loaded
        component: BalanceSheetPage,
        meta: { authRequired: true },
    },
    {
        path: '/bank-account',
        name: 'bank_account',
        // lazy-loaded
        component: BankAccountPage,
        meta: { authRequired: true },
    },
    {
        path: '/import-export',
        name: 'import_export',
        // lazy-loaded
        component: ImportExportPage,
        meta: { authRequired: true },
    },
    {
        path: '/user',
        name: 'user',
        // lazy-loaded
        component: UserPage,
        meta: { authRequired: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if(to.params.hasOwnProperty('account')) {
        localStorage.setItem('account_name', to.params.account)
    } else {
        localStorage.removeItem('account_name')
    }
    
    const loggedIn = store.state.profil?.user

    // trying to access a restricted page + not logged in
    // redirect to login page
    if(to.meta.authRequired && !loggedIn) {
        next({ name: 'login' })
    } else {
        next();
    }
});

export default router;
